var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLookingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34692 0C2.39249 0 0 2.39249 0 5.34692C0 8.30134 2.39249 10.6938 5.34692 10.6938C6.59425 10.6938 7.74153 10.2532 8.65042 9.5359L9.12722 10.0127C8.92714 10.3894 8.99738 10.8705 9.31453 11.1877L11.8177 13.7079C12.2072 14.0974 12.8415 14.0974 13.2311 13.7079L13.7079 13.2311C14.0974 12.8415 14.0974 12.2072 13.7079 11.8177L11.1877 9.31453C10.8684 8.99525 10.3894 8.93991 10.0127 9.14425L9.5359 8.66745C10.2575 7.75643 10.6938 6.60063 10.6938 5.34692C10.6938 2.39249 8.30134 0 5.34692 0ZM5.34692 0.987647C7.7543 0.987647 9.70618 2.93953 9.70618 5.34692C9.70618 7.7543 7.7543 9.70618 5.34692 9.70618C2.93953 9.70618 0.987647 7.7543 0.987647 5.34692C0.987647 2.93953 2.93953 0.987647 5.34692 0.987647ZM2.58832 3.96762C2.30735 4.42313 2.14558 4.95952 2.14558 5.53423C2.14558 7.18385 3.47592 8.5142 5.12555 8.5142C5.76198 8.5142 6.3601 8.30773 6.84541 7.96929C6.71557 7.98419 6.57083 7.98632 6.43673 7.98632C4.30393 7.98632 2.58832 6.27071 2.58832 4.1379C2.58832 4.08043 2.58619 4.02509 2.58832 3.96762Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookingGlass);
export default __webpack_public_path__ + "static/media/LookingGlass.8bf9c73f0852b5bea0f58974b1f01049.svg";
export { ForwardRef as ReactComponent };